import React from 'react';
import { connect } from 'react-redux';

import { getClientAllowanceItemList, deleteAllowanceItem } from 'src/reducers/clients/allowanceItems';
import {
  CLIENT_ALLOWANCE_ITEM_NEW,
  CLIENT_SETTINGS,
  CLIENT_ALLOWANCE_ITEM_CHANGE_DISPLAY_ORDERS
} from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import ActionButton from 'jbc-front/components/ActionButton';
import { Plus, Drugging } from 'jbc-front/components/icons';
import AllowanceItemsTable from './AllowanceItemsTable';
import styles from './ClientAllowanceItemsComponent.scss';
import { withTranslation } from 'react-i18next';

class ClientAllowanceItemsComponent extends React.Component {
  render() {
    const { allowanceItems, handleDeleteAllowanceItem } = this.props;

    return (
      <div>
        <div className="l-main-title-wrap">
          <h1 className="m-title-main">{this.props.t('features.ClientAllowanceItems.components.ClientAllowanceItemsComponent.attendance_items_setting_list')}</h1>
        </div>
        <div className="l-wrap-xl l-contents-wrap">
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={this.props.t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
              <BreadCrumb.Item label={this.props.t('features.ClientAllowanceItems.components.ClientAllowanceItemsComponent.attendance_items_setting_list')} />
            </BreadCrumb>
          </div>
          <div className={styles.action}>
            <ActionButton as="a" href={CLIENT_ALLOWANCE_ITEM_NEW} icon={<Plus size={10} />}>
              {this.props.t('features.ClientAllowanceItems.components.ClientAllowanceItemsComponent.add_item')}
            </ActionButton>
            <ActionButton as="a" href={CLIENT_ALLOWANCE_ITEM_CHANGE_DISPLAY_ORDERS} icon={<Drugging size={10} />}>
              {this.props.t('features.ClientAllowanceItems.components.ClientAllowanceItemsComponent.rearrange_items')}
            </ActionButton>
          </div>
          <AllowanceItemsTable allowanceItems={allowanceItems} handleDeleteRow={handleDeleteAllowanceItem} />
        </div>
      </div>
    );
  }
}

export default withTranslation('translation')(connect(
  state => ({
    allowanceItems: getClientAllowanceItemList(state)
  }),
  dispatch => ({
    handleDeleteAllowanceItem: allowanceItem => dispatch(deleteAllowanceItem(allowanceItem))
  })
)(ClientAllowanceItemsComponent));
